import React, { useContext, memo } from 'react';
import styles from './SimplifiedCharts.module.css';
import GaugeChart from 'react-gauge-chart';
import { isBrowser, isMobile, isMobileOnly } from 'react-device-detect';
import { AllInputDataContext } from '../../../../config';
import { Typography, Button } from 'antd';
import { startCase } from 'lodash';
import { playColors } from '../../../../constants';
const { Text, Title, Paragraph } = Typography;

const SimplifiedChartsTop = ({
  myRef,
  guageChartID,
  name,
  simpleData,
  show,
  onClick,
  style,
}) => {
  const { simplifiedData } = useContext(AllInputDataContext);

  return (
    <div
      ref={myRef}
      onClick={onClick}
      style={{ ...style, display: show ? '' : 'none' }}
      className={styles.simplifiedChartTop}
    >
      <Title
        level={4}
        style={{
          margin: 0,
          marginBottom: 5,
          padding: 0,
          fontSize: isMobileOnly ? 16 : isMobile ? 20 : 24,
        }}
      >
        {startCase(name)}
      </Title>
      <div className={styles.imgContainer}>
        <img
          src={simpleData.img.src}
          alt="line drawing of a house"
          width={simpleData.img.width}
        />
      </div>
      <Title level={5} style={{ margin: 4, padding: 0 }}>
        {simpleData.realisticValue}
      </Title>
      <Paragraph style={{ lineHeight: 1 }}>
        {simplifiedData[name].realityDescription}
      </Paragraph>

      <GaugeChart
        animate
        className={styles.guageChartContainer}
        id={'chart' + guageChartID}
        marginInPercent={0.02}
        nrOfLevels={4}
        percent={simpleData.percentage}
        formatTextValue={() => ''}
        textColor={playColors.black}
        needleColor={playColors.black}
        animateDuration={3000}
        animDelay={0}
      />

      <Text
        style={
          isBrowser ? { fontWeight: 'bold', lineHeight: 1 } : { lineHeight: 1 }
        }
      >
        {simplifiedData[name].guageTitle}
      </Text>
    </div>
  );
};

const alertName = ['one', 'two', 'three', 'four', 'five', 'six'];

const SimplifiedChartsBottom = memo(
  ({ name, simpleData, show, style, onBack, showHeading }) => {
    const { simplifiedData, optionsData } = useContext(AllInputDataContext);

    return (
      <div
        className={styles.simplifiedChartBottomContainer}
        style={{
          ...style,
          display: show ? '' : 'none',
        }}
      >
        {!showHeading && (
          <div
            className={styles.simplifiedChartBottomHeader}
            style={{
              borderColor:
                simpleData.alertLevel === 0 || simpleData.alertLevel >= 3
                  ? playColors.white
                  : playColors.black,
              backgroundColor:
                optionsData[`alertLevel${simpleData.alertLevel}`],
            }}
          >
            <Title
              style={{
                margin: 5,
                color:
                  simpleData.alertLevel === 0 || simpleData.alertLevel >= 3
                    ? playColors.white
                    : playColors.black,
              }}
              level={3}
            >
              {alertName[simpleData.alertLevel]}
            </Title>
          </div>
        )}
        <div
          className={styles.simplifiedChartBottom}
          style={{
            borderColor: optionsData[`alertLevel${simpleData.alertLevel}`],
          }}
        >
          {showHeading && (
            <Title level={5} style={{ margin: 0 }}>
              {simpleData.alertLevel < 2 ? 'Great job on: ' : 'Focus on:'}{' '}
              {startCase(name)}
            </Title>
          )}
          <Paragraph style={{ lineHeight: 1.25 }}>
            {simplifiedData[name][`alertLevel${simpleData.alertLevel}`]}
          </Paragraph>
        </div>
        {onBack && <Button onClick={onBack}>back</Button>}
      </div>
    );
  }
);

export { SimplifiedChartsTop, SimplifiedChartsBottom };
